import _ from 'lodash'
import * as React from 'react'
import { useFilterOptions } from '../../hooks/useFilterOptions'
import AutocompleteFilter from './AutocompleteFilter'
import SelectorFilter from './SelectorFilter'
import ButtonControl from './ButtonControl'

const WIDTHMIN = 375
const FirstSearchBox = ({ advancedSearch, ...rest }) => {
  const w = Boolean(rest.windowWidth < 600)

  const {
    type,
    usedType,
    filterList1,
    usedFilter1,
    filterList2,
    usedFilter2,
    boxHeight,
  } = rest

  const rawOptions = useFilterOptions(type)

  const options = React.useMemo(() => {
    if (!rawOptions) return null
    const normalized = _.map(rawOptions, item => ({
      ...item,
      options: _.sortBy(item.options, o => _.toLower(o.title || '')),
    }))
    return _.sortBy(normalized, item => _.toLower(_.deburr(item.title || '')))
  }, [rawOptions])

  const toFilter = {
    type,
    usedType,
    filterList1,
    usedFilter1,
    filterList2,
    usedFilter2,
    boxHeight,
  }

  const boxGrew = () => {
    if (!Boolean(boxHeight)) return false
    return boxHeight > 60
  }
  const propsDefault = { boxGrew, toFilter, options, WIDTHMIN, w, ...rest }
  const prpsControl = { boxGrew, WIDTHMIN, ...rest }

  // Activate or deactivate the search button if there are new changes in the basic text input box.
  React.useEffect(() => {
    if (
      _.includes(
        [
          'pseudonym',
          'specie',
          'family',
          'site',
          'sitetype',
          'zonetype',
          'diseases',
          'pests',
          'physical_problems',
          'suggestions',
        ],
        type
      )
    ) {
      if (!Boolean(filterList1.length)) return
      rest.setEnableFilterButton(_.isEqual(filterList1, usedFilter1))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterList1])

  // Activate or deactivate the search button if there are new changes in the composite text input box.
  React.useEffect(() => {
    let changeFilter1 = false
    if (_.includes(['feature', 'phytosanitary', 'potential_risks'], type)) {
      if (Boolean(filterList1.length))
        if (!_.isEqual(filterList1, usedFilter1)) changeFilter1 = true

      if (Boolean(filterList2.length)) {
        if (changeFilter1) rest.setEnableFilterButton(false)
        else rest.setEnableFilterButton(_.isEqual(filterList2, usedFilter2))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterList2])

  if (!type || !options) return <ButtonControl {...prpsControl} />
  // if (!type || !options) return null

  if (_.includes(['sitetype', 'zonetype', 'feature', 'phytosanitary', 'potential_risks'], type)) {
    return (
      <SelectorFilter {...propsDefault}>
        <ButtonControl {...prpsControl} />
      </SelectorFilter>
    )
  }

  return (
    <AutocompleteFilter {...propsDefault}>
      <ButtonControl {...prpsControl} />
    </AutocompleteFilter>
  )
}

export default FirstSearchBox
